import { PropsWithChildren } from 'react'

type ActionsProps = {}

export const Actions = ({ children }: PropsWithChildren<ActionsProps>) => {
  return (
    <div className="p-6 grid grid-cols-2 bg-white gap-2 z-10">{children}</div>
  )
}
